import FeaturesManager from './FeaturesManagerContainer'
export default FeaturesManager
